import { ValidationResult } from "../ruleValidator";
import { RuleValidator } from "../ruleValidator";

export class RangeValidator extends RuleValidator {

    private start: number;
    private end: number;

    private static rulePattern = /range\[(?<start>\d+(\.\d+)?):(?<end>\d+(\.\d+)?)\]/;

    constructor(start: number, end: number) {
        super()
        if (start >= end) {
            throw new Error(`Invalid range: start <${start}> should be less than end <${end}>.`);
        }
        this.start = start;
        this.end = end;
    }

    static parse(rule: string): RuleValidator | null {
        const matchedRule = rule.match(RangeValidator.rulePattern);
        if (!matchedRule || !matchedRule.groups) {
            return null;
        }

        const start = parseFloat(matchedRule.groups.start);
        const end = parseFloat(matchedRule.groups.end);

        return new RangeValidator(start, end);
    }

    public getValidationMessage(): string {
        return `Number must be between ${this.start} and ${this.end}`;
    }

    public apply(value: string): ValidationResult {
        const numValue = parseFloat(value);
    
        if (isNaN(numValue)) {
            return {
                valid: false,
                message: `Value <${value}> is not a valid number.`,
            };
        }
    
        const isInRange = numValue >= this.start && numValue <= this.end;
    
        return {
            valid: isInRange,
            message: isInRange ? "" : "validationRule.numeric.range.outside",
            values: isInRange ? undefined : { start: this.start, end: this.end },
        };
    }
    
}
